export default __webpack_public_path__ + "static/media/Logo-rene.da02564e.png";